const EVENTS_DE = {
  accepted: "Angebot vom Kunden angenommen",
  booking_auto_extended: "Automatische Verlängerung",
  booking_end: "Buchungsende-Anfrage",
  booking_extension: "Verlängerungsanfrage",
  break_repair: "Große Schäden",
  break_repair_2: "Kleine Schäden",
  breakdown: "Panne",
  breakdown_electric: "Elektrischer Defekt",
  breakdown_engine: "Motorschaden",
  breakdown_mecanic: "Mechanischer Defekt",
  breakdown_other: "Anderer Defekt",
  canceled: "Storniert",
  closed: "Geschlossen",
  confirmed: "Bestellung bestätigt",
  damages_third_parties: "Rechtlicher Schadensanspruch",
  delay_in_delivery: "Lieferverzögerung",
  deliveryOn: "Lieferung am",
  document_compliance: "Dokumenten-Compliance",
  events: "{{count}} Ereignisse",
  forgetting_extend: "Verlängerung vergessen",
  forgetting_recover: "Rückholung vergessen",
  from_date: "Beginn",
  hours_record: "Stundenerfassung",
  immobilisation: "Stilllegung",
  incompetent_operator: "Unqualifizierter Bediener",
  inventory: "Inventar",
  keys: "Schlüssel/Code: Verlust/nicht mitgeteilt",
  machine_delivery: "Lieferung",
  machine_retrieval: "Abholung",
  missing_accessory: "Fehlendes Zubehör",
  n1_control: "N1 Kontrolle",
  n2_control: "N2 Kontrolle",
  n3_control: "N3 Kontrolle",
  no_show: "Lieferung: Nicht erschienen",
  open: "Offen",
  openEvents: "Offene Ereignisse",
  operator_change: "Bedienerwechsel",
  other: "Sonstiges",
  other_delivery: "Andere Lieferung",
  other_request: "Andere Anfrage",
  quality_issue: "Ausrüstung in schlechtem Zustand",
  retrievalOn: "Abholung am",
  robbery_accessory: "Zubehördiebstahl",
  robbery_article: "Maschinendiebstahl",
  sent: "Anfrage erhalten",
  to_date: "Ende",
  undeclared_use: "Nicht gemeldete Nutzung",
  validated: "Buchungsanfrage bestätigt",
  weather: "Schlechtes Wetter",
  wrong_machine: "Ausrüstungsfehler",
  wrong_reclassification: "Falsche Maschinenauswahl",
} as const;

export default EVENTS_DE;
